<div class="step-title">
  <button matIconButton type="button" aria-label="Indietro" (click)="flow.back()">
    <i class="fa-regular fa-arrow-left" aria-hidden="true"></i>
  </button>
  <span class="title-medium-emphasized">Contatti</span>
</div>

<form class="step-fields step-fields--half" [formGroup]="form" (ngSubmit)="continue()">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Nominativo *</mat-label>
    <input matInput formControlName="nominativo" maxlength="100">
    <i matSuffix class="fa-regular fa-user" aria-hidden="true"></i>
    @if (form.controls.nominativo.hasError('required')) {
      <mat-error>Campo obbligatorio</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Ruolo</mat-label>
    <input matInput formControlName="ruolo" maxlength="50">
    <i matSuffix class="fa-regular fa-briefcase" aria-hidden="true"></i>
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Telefono</mat-label>
    <input matInput type="tel" inputmode="numeric" formControlName="telefono" maxlength="20">
    <i matSuffix class="fa-regular fa-phone" aria-hidden="true"></i>
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Email *</mat-label>
    <input matInput type="email" formControlName="email" maxlength="100">
    <i matSuffix class="fa-regular fa-envelope" aria-hidden="true"></i>
    @if (form.controls.email.hasError('required')) {
      <mat-error>Campo obbligatorio</mat-error>
    } @else if (form.controls.email.hasError('email')) {
      <mat-error>Indirizzo email non valido</mat-error>
    }
  </mat-form-field>

  <mat-form-field class="step-field--wide text-area-custom" appearance="outline" subscriptSizing="dynamic">
    <mat-label>Note</mat-label>
    <textarea matInput rows="4" formControlName="note" maxlength="500"></textarea>
  </mat-form-field>
</form>

<div class="step-actions">
  <button matButton="filled" type="button" [disabled]="!valid || flow.loading()" (click)="continue()">Prosegui</button>
</div>
